import React, { FC } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Box from '@material-ui/core/Box';
import SvgIcon from '@material-ui/core/SvgIcon';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import styled from 'styled-components';

import { Link } from '../Link';
import { Icon } from '../Icon';

const StyledAppBar = styled(AppBar)`
  &&& {
    box-shadow: none;
  }
`;

interface Item {
  Icon?: typeof SvgIcon;
  name: string;
  link: string;
}

interface NavBarProps {
  items?: Item[];
  open?: boolean;
  anchor?: 'left' | 'top' | 'right' | 'bottom';
  handleClose?: () => void;
  Logo?: React.ReactElement;
}

const ItemLink = (item: Item) => {
  return (
    <ListItem button key={item.name}>
      {item.Icon && (
        <ListItemIcon>{<Icon Component={item.Icon} />}</ListItemIcon>
      )}
      <ListItemText primary={item.name} />
    </ListItem>
  );
};

export const NavBar: FC<NavBarProps> = ({
  items,
  open,
  anchor,
  handleClose,
  Logo,
  children,
}) => {
  return (
    <StyledAppBar position="static" color="transparent">
      <Toolbar>
        {children}
        {items && (
          <Drawer anchor={anchor ?? 'left'} open={open} onClose={handleClose}>
            <List>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
              >
                {Logo && (
                  <Link key="home" to="/">
                    {Logo}
                  </Link>
                )}
                <IconButton color="inherit" onClick={handleClose}>
                  <ChevronLeftIcon />
                </IconButton>
              </Box>
              {items.map((item) => (
                <span
                  key={item.name}
                  onClick={handleClose}
                  role="button"
                  aria-hidden="true"
                >
                  <Link key={item.name} to={item.link}>
                    <ItemLink {...item} />
                  </Link>
                </span>
              ))}
            </List>
          </Drawer>
        )}
      </Toolbar>
    </StyledAppBar>
  );
};
